import { reactive as s, readonly as i } from "vue";
import { getCache as o, KnownDomain as C } from "@ado/client-side-caching";
var y = /* @__PURE__ */ ((r) => (r.Countries = "countries", r.CurrentCountry = "currentCountry", r.CountryRegions = "countryRegions", r))(y || {});
const t = s({
  currentCountry: {},
  currentCountryRegions: [],
  countries: []
}), R = () => {
  t.countries = [], t.currentCountryRegions = [], t.currentCountry = {};
}, m = () => i(t), d = (r) => {
  t.currentCountry = r, u(
    "currentCountry",
    t.currentCountry,
    t.currentCountry.countryCode
  );
}, h = (r) => {
  t.countries = r, u("countries", t.countries);
};
function v(r, n) {
  t.currentCountryRegions = n, u(
    "countryRegions",
    t.currentCountryRegions,
    r
  );
}
const f = (r, n = void 0) => {
  const e = o().getItem(
    c(r, n)
  );
  if (e !== void 0)
    switch (r) {
      case "countries":
        t.countries = e;
        break;
      case "countryRegions":
        t.currentCountryRegions = e;
        break;
      case "currentCountry":
        t.currentCountry = e;
        break;
    }
}, u = (r, n, e = void 0) => {
  o().setItem(c(r, e), n);
}, c = (r, n) => o().createKey(
  C.Foundation,
  "location",
  r,
  n
);
export {
  y as LocationPart,
  m as getLocation,
  R as resetLocation,
  f as restoreLocationPartFromCache,
  h as setCountries,
  d as setCurrentCountry,
  v as setCurrentCountryRegions
};
//# sourceMappingURL=index.js.map
